/** @jsx h */

import Masonry from 'masonry-layout';
import $ from 'jquery';
import {h, render} from 'preact';
import {component} from '@reduct/component';

import Gallery from './Components/Gallery/index';
import Lightbox from './Components/Lightbox/index';

import app from '../../assembler';

const extractImageUrls = imageNodes => imageNodes.map(img => {
	const options = JSON.parse(img.dataset.options || '{}') || {};
	return {
		src: options.large || img.src,
		description: options.description || img.alt
	};
});

@component()
export default class TiledTeaser {
	constructor() {
		const el = this.getElement();
		const $grid = new Masonry(el, {
			percentPosition: false,
			itemSelector: '.tiledTeaser',
			isInitLayout: false
		});

		$grid.layout();

		$('body').on('webkitTransitionEnd transitionend msTransitionEnd oTransitionEnd DOMNodeInserted', function () {
			$grid.layout();
		});

		window.onload = function () {
			$grid.layout();
		}

		if (el.dataset.enableGallery == 'on') {
			const surrogate = document.createElement('div');
			const imageNodes = [].slice.call(el.querySelectorAll('.tiledTeaser__bg__image > img'));
			const images = extractImageUrls(imageNodes);

			document.body.appendChild(surrogate);

			imageNodes.forEach(img => img.parentNode.classList.add('tiledTeaser__bg__image--opensLightboxGallery'));

			let root;
			const renderSurrogate = () => {
				root = render(
					<Lightbox
						opener={imageNodes.map(img => img.parentNode)}
					>
						{images.length && (<Gallery
							trigger={imageNodes}
							images={images}
						/>)}
					</Lightbox>,
					surrogate,
					root
				);
			};

			renderSurrogate();
		}
	}
}

app.register(TiledTeaser, 'TiledTeaser');
